import { CurrencyPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { Button } from 'primeng/button';
import { InputNumberModule } from 'primeng/inputnumber';
import { NgxAimStationOptionsClass } from './ngx-aim-station-options.class';

@Component({
  selector: 'ngx-aim-station-options',
  standalone: true,
  imports: [Button, RouterLink, InputNumberModule, CurrencyPipe, FormsModule],
  templateUrl: './ngx-aim-station-options.component.html',
  styleUrl: './ngx-aim-station-options.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NgxAimStationOptionsComponent extends NgxAimStationOptionsClass implements OnInit {
  ngOnInit() {
    this.init();
  }
}
